import { api } from "@/api/api";

export const Afterservice = {
    state: {
        afterserviceList: [],
        totalCount: 0,
        afterserviceId: null,
    },
    getters: {
        getAfterserviceList(state) {
            return state.afterserviceList;
        },
        getAfterserviceId(state) {
            return state.afterserviceId;
        },
        getAfterserviceTotalCount(state) {
            return state.totalCount;
        }
    },
    mutations: {
        setAfterserviceList(state, payload) {
            state.afterserviceList = payload;
        },
        setAfterserviceId(state, payload) {
            state.afterserviceId = payload;
        },
        setAfterserviceTotalCount(state, payload) {
            state.totalCount = payload;
        }
    },
    actions: {
        async getAfterserviceList({ commit }, param) {
            await api.afterservice
                .getAfterserviceList(param)
                .then((res) => {
                    commit("setAfterserviceList", res.data.afterservice);
                    commit("setAfterserviceTotalCount", res.data.total);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getAfterservice(_, id) {
            const response = await api.afterservice
                .getAfterservice(id)
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve(response.data);
        },

        async addAfterservice({ dispatch }, args) {
            await api.afterservice
                .addAfterservice(args)
                .then(() => {
                    dispatch("getAfterserviceList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateAfterservice({ dispatch }, args) {
            await api.afterservice
                .updateAfterservice(args)
                .then(() => {
                    dispatch("getAfterserviceList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteAfterservice({ dispatch }, args) {
            await api.afterservice
                .deleteAfterservice(args.id)
                .then(() => {
                    dispatch("getAfterserviceList", args.param);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async verifyPin(_, args) {
            const response = await api.afterservice
                .verifyPin(args)
                .catch((err) => {
                    console.log("err:", err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve(response.data);
        },
    },
};
